/**
 * Controls mobile navigation and dropdown interactions.
 */
document.addEventListener('DOMContentLoaded', function() {

    const menuBtn = document.querySelector('.mobile-menu-btn');
    const nav = document.querySelector('.main-nav');
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    
    // Mobile menu toggle
    if (menuBtn && nav) {
        menuBtn.addEventListener('click', function() {
            menuBtn.classList.toggle('active');
            nav.classList.toggle('active');
            document.body.classList.toggle('menu-open');
            
           // console.log('Menu button clicked. Nav active:',  menuBtn);

           // When navigation is closed, remove "open" class on all dropdown parent items.
            if (!nav.classList.contains('active')) {
                document.querySelectorAll('.has-dropdown').forEach(function(item) {
                    item.classList.remove('open');
                });
            }
        });
    }

    // Dropdown toggles: Ensure only one dropdown is open at all times.
    dropdownToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
            if (window.innerWidth <= 1024) {
                e.preventDefault();
                const parentItem = this.closest('.has-dropdown');
                
                // Close all other open dropdowns.
                document.querySelectorAll('.has-dropdown.open').forEach(function(item) {
              
                    if (item !== parentItem) {
                        item.classList.remove('open');
                    }
                });
                
                // Toggle the clicked dropdown.
                parentItem.classList.toggle('open');
            }
        });
    });

    // FIXME: need to look into again
// This will target both primary nav links (that are not dropdown toggles)
// and also dropdown sublinks.
document.querySelectorAll('.nav-link:not(.dropdown-toggle), .dropdown-sublink').forEach(function(link) {
    link.addEventListener('click', function() {
        if (window.innerWidth <= 1024) {
            // Close the mobile nav
            if (nav) nav.classList.remove('active');
            if (menuBtn) menuBtn.classList.remove('active');
            document.body.classList.remove('menu-open');
            // Close any open dropdowns
            document.querySelectorAll('.has-dropdown').forEach(function(item) {
                item.classList.remove('open');
            });
        }
    });
});

     // On window resize, if width > 1024 remove active classes.
    window.addEventListener('resize', function() {
        if (window.innerWidth > 1024) {
            // Remove active states
            if (nav) nav.classList.remove('active');
            if (menuBtn) menuBtn.classList.remove('active');
            document.body.classList.remove('menu-open');
            document.querySelectorAll('.has-dropdown').forEach(function(item) {
                item.classList.remove('open');
            });
        }
    });

   
    // Get the current year
    var currentYear = new Date().getFullYear();

    // Find the footer-bottom element
    var footerBottom = document.querySelector('.footer-copyright p');

    // Replace [year] with the current year
    if (footerBottom) {
        footerBottom.innerHTML = footerBottom.innerHTML.replace('[year]', currentYear);
    }

});